<template>
  <div class="big">
    <div class="page_title flex_between">
      <div>
        <span style="margin-right:20px">体检订单详情</span>
        <span class="pending" v-if="status==1">未支付</span>
        <span class="pay" v-if="status==2||status==3">已支付</span>
        <span class="finish" v-if="status==4">已完成</span>
        <span class="cancel" v-if="status==5||status==6">已作废</span>
        <span class="confirm" v-if="market_status==1" style="margin-left:20px">业务已确认</span>
      </div>
      <el-button type="primary" style="width:92px;" size="medium" @click="back">返回</el-button>
    </div>

    <div style="padding:20px;width:100%;;box-sizing: border-box;">
      <div style="background:#fff">
        <div class="container">
          <div class="inbobox">
            <div class="inboitem">
              <div>
                <span class="infotitle">用户昵称：</span>
                <span>{{detail.nick_name}}</span>
              </div>
              <div style="margin:12px 0">
                <span class="infotitle">性别：</span>
                <span v-if="detail.user_sex==1">男</span>
                <span v-if="detail.user_sex==2">女</span>
                <span v-if="detail.user_sex==0">未知</span>
              </div>
              <div>
                <span class="infotitle">手机号：</span>
                <span>{{detail.user_phone}}</span>
              </div>
            </div>
            <div class="inboitem">
              <div>
                <span class="infotitle">患者姓名：</span>
                <span>{{detail.user_name}}</span>
              </div>
              <div style="margin:12px 0">
                <span class="infotitle">性别：</span>
                <span v-if="detail.sex==1">男</span>
                <span v-if="detail.sex==2">女</span>
                <span v-if="detail.sex==0">未知</span>
              </div>
              <div>
                <span class="infotitle">年龄：</span>
                <span>{{detail.age}}</span>
              </div>
            </div>
            <div class="inboitem">
              <div>
                <span class="infotitle">医生姓名：</span>
                <span>{{detail.doctor_name}}</span>
              </div>
              <div style="margin:12px 0">
                <span class="infotitle">性别：</span>
                <span v-if="detail.doctor_sex==1">男</span>
                <span v-if="detail.doctor_sex==2">女</span>
                <span v-if="detail.doctor_sex==0">未知</span>
                <span style="margin:0 10px 0 50px">职称：</span>
                <span>{{detail.doctor_title}}</span>
              </div>
              <div>
                <span class="infotitle">手机号：</span>
                <span>{{detail.doctor_phone}}</span>
              </div>
            </div>
          </div>
          <div class="probox">
            <span>
              <span class="pro_title">推荐时间</span>
              <span>{{detail.recommend_time}}</span>
            </span>
            <span>
              <span class="pro_title">项目类型</span>
              <span v-if="detail.pro_type==1">体检项目</span>
            </span>
            <span>
              <span class="pro_title">项目名称</span>
              <span>{{detail.pro_name}}</span>
            </span>
            <span>
              <span class="pro_title">销售价格</span>
              <span>{{detail.price}}</span>
            </span>
          </div>
          <div class="probox" v-if="status==5||status==6">
            <span>
              <span class="pro_title">作废类型</span>
              <span v-if="detail.status==5">平台退款</span>
              <span v-if="detail.status==6">超时作废</span>
            </span>
          </div>
          <div class="probox" v-if="detail.pay_time">
            <span>
              <span class="pro_title">支付时间</span>
              <span>{{detail.pay_time}}</span>
            </span>
            <span v-if="status==4">
              <span class="pro_title">完成时间</span>
              <span>{{detail.recommend_time}}</span>
            </span>
          </div>
          <div class="probox" v-if="status==2||status==3||status==4||status==5">
            <span>
              <span class="pro_title">体检人姓名</span>
              <span>{{detail.look_name}}</span>
            </span>
            <span>
              <span class="pro_title">身份证号</span>
              <span>{{detail.id_card}}</span>
            </span>
            <span>
              <span class="pro_title">手机号</span>
              <span>{{detail.look_phone}}</span>
            </span>
            <el-button
              type="primary"
              @click="remind"
              v-if="!detail.look_name||!detail.id_card||!detail.look_phone"
              :disabled="module_id_array[0]?!module_id_array.includes('300'):false"
            >提醒患者补填</el-button>
          </div>
          <div class="yuyuebox" v-if="status==2||status==3||status==4||status==5">
            <div>
              <span class="yutitle">业务员：</span>
              <span>{{detail.recommender_name}}</span>
            </div>
            <div style="margin:5px 0">
              <span class="yutitle">预约时间：</span>
              <span>{{detail.register_time}}</span>
            </div>
            <div>
              <span class="yutitle">分院：</span>
              <span>{{detail.phy_name}}</span>
            </div>
            <div style="margin:5px 0">
              <span class="yutitle">地址：</span>
              <span>{{detail.address}}</span>
            </div>
          </div>
          <div style="text-align:center;margin-top:20px">
            <el-button
              type="primary"
              style="width:120px;margin-right:20px"
              @click="finishOrder"
              v-if="detail.register_time&&(status==2||status==3)"
            >完成</el-button>
            <el-button plain style="width:120px" @click="refund" v-if="status==2||status==3">退款</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import marketing from "../../../api/marketing";
import moment from "moment";

export default {
  data() {
    return {
      detail: {},
      status: "",
      market_status: ""
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取详情
    getDetail() {
      let order_id = this.$route.query.order_id;
      marketing.getProductOrderDetail({ order_id }).then(res => {
        if (res.code == 0) {
          this.detail = res.data.info;
          this.status = this.detail.status;
          this.market_status = this.detail.market_status;
          this.detail.recommend_time = moment
            .unix(this.detail.recommend_time)
            .format("YYYY-MM-DD HH:mm");
          this.detail.pay_time = this.detail.pay_time
            ? moment.unix(this.detail.pay_time).format("YYYY-MM-DD HH:mm")
            : "";
          this.detail.register_time = this.detail.register_time
            ? moment.unix(this.detail.register_time).format("YYYY-MM-DD HH:mm")
            : "";
        }
      });
    },
    back() {
      history.back();
    },
    //完成订单
    finishOrder() {
      let order_id = this.$route.query.order_id;
      if (this.market_status) {
        this.$confirm(
          "业务员已经确认体验完成了。是否完成该体检套餐？",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消"
          }
        )
          .then(() => {
            marketing.updateProductOrderStatus({ order_id }).then(res => {
              if (res.code == 0) {
                this.$message.success("订单已完成");
                this.getList();
              }
            });
          })
          .catch(() => {});
      } else {
        this.$confirm(
          "业务员还未确认体检是否完成。是否要继续完成该体检套餐？",
          "提示",
          {
            confirmButtonText: "不需确认，继续完成",
            cancelButtonText: "取消"
          }
        )
          .then(() => {
            marketing.updateProductOrderStatus({ order_id }).then(res => {
              if (res.code == 0) {
                this.$message.success("订单已完成");
                this.back();
              }
            });
          })
          .catch(() => {});
      }
    },
    //退款
    refund() {
      let order_id = this.$route.query.order_id;

      this.$confirm("确定要退款吗？退款后项目订单将作废", "提示", {
        confirmButtonText: "确定退款",
        cancelButtonText: "取消"
      })
        .then(() => {
          marketing.refundProductOrder({ order_id }).then(res => {
            if (res.code == 0) {
              this.$message.success("订单已退款");
              this.back();
            }
          });
        })
        .catch(() => {});
    },
    //提醒患者补填信息
    remind() {
      let order_id = this.$route.query.order_id;
      marketing.writeMessagePush({ order_id }).then(res => {
        if (res.code == 0) {
          this.$message.success("提醒成功");
        }
      });
    }
  },
  created() {
    this.getDetail();
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  border-radius: 5px;
  text-align: left;
  width: 920px;
  .pending {
    font-size: 16px;
    color: #00a1ff;
    background: #bfe7ff;
    padding: 4px 6px;
  }
  .pay {
    font-size: 16px;
    color: #1ebf33;
    background: #badfbf;
    padding: 4px 6px;
  }
  .confirm {
    font-size: 16px;
    color: #d51717;
    background: #e89595;
    padding: 4px 6px;
  }
  .finish {
    font-size: 16px;
    color: #e06400;
    background: #eab489;
    padding: 4px 6px;
  }
  .cancel {
    font-size: 16px;
    color: #666;
    background: #e7e7e7;
    padding: 4px 6px;
  }
}
.inbobox {
  display: flex;
  width: 900px;
  justify-content: space-between;
  box-sizing: border-box;

  .inboitem {
    padding: 14px 50px 14px 20px;
    box-sizing: border-box;
    margin-bottom: 12px;
    margin-right: 20px;
    background-color: #f9f8ee;
    border: solid 1px #dad8ca;
    .infotitle {
      width: 90px;
      display: inline-block;
      font-weight: 600;
    }
  }
}
.probox {
  background: #f5f5f5;
  height: 50px;
  line-height: 50px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
  margin-bottom: 20px;
  align-items: center;
  .pro_title {
    font-weight: 600;
    margin-right: 10px;
  }
}
.yuyuebox {
  padding: 0 20px 20px;
  width: 100%;
  box-sizing: border-box;
  background: #f5f5f5;
  margin-top: -20px;
  .yutitle {
    color: #666;
    font-weight: 600;
    display: inline-block;
    width: 70px;
    text-align: right;
    margin-right: 10px;
  }
}
</style>
